<template>
  <Drawer
    :open="open"
    :backdrop-close-icon="false"
    placement="right"
    :classes="{ container: 'sm:!w-[421px]' }"
    sidebar-close-icon
    @on-close="closeNotificationDrawer"
  >
    <template #sidebar>
      <div class="px-5 py-4 flex items-center justify-between border-b border-app-gray-200">
        <div class="flex items-center gap-2">
          <Dropdown
            model-value="all"
            :label="dropDownLabel"
            :items="types"
            :button-props="{ variant: 'tertiary' }"
            :classes="{ item: '!text-sm' }"
            @on-item-click="handleDropdown"
          />
          <Badge v-if="unreadCount > 0" variant="danger" pill>{{ unreadCount }}</Badge>
        </div>
        <Button
          :disabled="getNewNotifications"
          variant="secondary"
          class="!text-sm hover:underline hover:disabled:no-underline mr-10"
          @on-click="markAllAsRead"
        >
          Mark all as read
        </Button>
      </div>
      <div v-if="notificationsByType?.length > 0" class="message-container">
        <NotificationItem v-for="(item, idx) in notificationsByType" :key="idx" :item="item" />
      </div>
      <div v-else class="px-5 py-5 text-base text-center w-full">No Notifications Found.</div>
    </template>
  </Drawer>
</template>

<script lang="ts">
import { Badge } from "@toruslabs/vue-components/Badge";
import { defineComponent } from "vue";

import { Button } from "@/components/Button";
import { Drawer } from "@/components/Drawer";
import { Dropdown } from "@/components/Dropdown";

import { notificationModule } from "../../../store";
import NotificationItem from "./NotificationItem";

export default defineComponent({
  name: "Notification",
  components: {
    Badge,
    Button,
    Drawer,
    Dropdown,
    NotificationItem,
  },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["onClose"],
  data: () => ({
    selectedType: "all",
    dropDownLabel: "All Updates",
    types: [
      { value: "all", name: "All Updates" },
      { value: "feature", name: "Features" },
      { value: "announcement", name: "Announcements" },
      { value: "bug fix", name: "Bug fixes" },
    ],
  }),
  computed: {
    getNewNotifications() {
      return notificationModule.newNotifications.length === 0;
    },
    notificationsByType() {
      if (this.selectedType === "all") return notificationModule.notifications;
      return notificationModule.notifications.filter((item: { type: string }) => item.type === this.selectedType);
    },
    unreadCount() {
      return this.notificationsByType.filter((item: { is_read: boolean }) => !item.is_read).length;
    },
  },
  created() {
    notificationModule.fetchUserNotifications();
  },
  methods: {
    async markAllAsRead() {
      const unreadNotifications = notificationModule.notifications.filter((item: { is_read: boolean }) => !item.is_read);
      await notificationModule.markNotificationsAsRead(unreadNotifications.map((item: { ID: number }) => item.ID));
    },
    closeNotificationDrawer() {
      this.$emit("onClose");
    },
    handleDropdown(item: { name: string; value: string }) {
      this.selectedType = item.value;
      this.dropDownLabel = item.name;
    },
  },
});
</script>

<style lang="scss" scoped>
@use "Notification.scss";
</style>
